import { PAGINATION_CHANGE_PAGE, PAGINATION_LOAD_MORE } from '../constEvents';
import ee from './eventemitter';

export default class Pagination {
    constructor({ contentContainer }) {
        this.$contentContainer = contentContainer;
        this.init();
    }

    _bindHandlers() {
        // this.$contentContainer.on('click', '.pagination__link', e => {
        //     e.preventDefault();
        //
        //     const $this = $(e.currentTarget);
        //     const $parentItem = $this.parent();
        //     const pageNumber = +$this.data('page-number');
        //
        //     if ($parentItem.hasClass('is-disable') || $parentItem.hasClass('is-active')) return;
        //
        //     ee.trigger(PAGINATION_CHANGE_PAGE, [{
        //         pageNumber
        //     }]);
        // });

        this.$contentContainer.on('click', '.pagination__load-more', this.loadMoreClickHandler);
    }

    loadMoreClickHandler = e => {
        e && e.preventDefault && e.preventDefault();

        const $this = $(e.currentTarget);

        if ($this.hasClass('is-disable')) return;

        ee.trigger(PAGINATION_LOAD_MORE);
    };

    destroy() {
        this.$contentContainer.off('click', '.pagination__load-more', this.loadMoreClickHandler);
        this.$contentContainer.find('.pagination').remove();
    }

    init() {
        this._bindHandlers();
    }
}



// WEBPACK FOOTER //
// ./components/pagintation.js